import { Box, Container, useTheme } from "@mui/material";
import React from "react";
import Title from "../../typography/Title";
import SimpleBox from "./SimpleBox";

// `title` is optional — when only one tier of partners exists on the whole
// site, the caller omits it, since showing a lone group name ("Ouro") with
// nothing to distinguish it from would be confusing.
const PartnerGroup = ({ title, maxWidth = "md", mt = 10, mb = 10, partners = [] }) => {
    const theme = useTheme();

    return (
        <Container maxWidth={maxWidth} sx={{ marginTop: theme.spacing(mt), marginBottom: theme.spacing(mb) }}>
            <Box sx={{ boxShadow: theme.shadows[5], borderRadius: theme.spacing(6), paddingY: theme.spacing(4), backgroundColor: theme.palette.white.dark }}>
                {title ? <Title label={title} variant="h2" pt={2} pl={10} /> : null}
                <SimpleBox pt={10} pb={10} justifyContent="space-around" flexWrap="wrap" gap={10}>
                    {partners.map((partner, index) => {
                        const image = partner.logoUrl ? (
                            <img
                                key={index}
                                src={partner.logoUrl}
                                alt={partner.name}
                                style={{ maxHeight: "100px", maxWidth: "220px", objectFit: "contain" }}
                            />
                        ) : null;
                        if (!image) return null;
                        return partner.linkUrl ? (
                            <a key={index} href={partner.linkUrl} target="_blank" rel="noreferrer">
                                {image}
                            </a>
                        ) : image;
                    })}
                </SimpleBox>
            </Box>
        </Container>
    );
}

export default PartnerGroup;
